import { PortfolioModel } from '../../portfolios/shared/models/portfolio-model';
import { PortfolioService } from '../../portfolios/shared/services/portfolio.service';
import { Locality } from '../../shared/models/locality.model';
import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { LookupService } from '../../shared/services/lookup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomerModel } from '../shared/models/customer-model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerService } from '../shared/services/customer.service';
import { IndustryOption } from '@admin/shared/models/industry.model';

@Component({
  selector: 'hr-customer-edit-view',
  templateUrl: './customer-edit-view.component.html',
  styleUrls: ['./customer-edit-view.component.less'],
  standalone: false,
})
export class CustomerEditViewComponent implements OnInit, OnDestroy {
  private customerId: number;
  public customer: CustomerModel;
  private sub: Subscription;

  public localities: Locality[];
  public emptyLookupItem: CommonLookupItem<number, string>;
  public industries: CommonLookupItem<number, string>[];
  public types: CommonLookupItem<number, string>[];
  public customerFeedTypes: CommonLookupItem<number, string>[];
  public numberOfEmployees: CommonLookupItem<number, string>[];
  public vatStatuses: CommonLookupItem<number, string>[];
  public customerContractTypes: CommonLookupItem<number, string>[];
  public tabIndex: number;
  public portfolios: PortfolioModel[];
  public industryOptions: IndustryOption[];

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private lookupService: LookupService,
    private portfolioService: PortfolioService
  ) {
    this.localities = [];
    this.industries = [];
    this.types = [];
    this.numberOfEmployees = [];
    this.vatStatuses = [];
    this.tabIndex = 0;
  }

  load(customerId: number): void {
    this.customerService
      .getCustomer(customerId)
      .subscribe((d) => (this.customer = d));
  }

  loadPortfoliosDropDown() {
    this.portfolioService.getPortfolios().subscribe((p) => {
      this.portfolios = p.items;
      let emptyPortfolio = <PortfolioModel>{
        portfolioId: null,
        name: '',
        comment: null,
        createDate: null,
        isDeleted: null,
        lastModifiedDate: null,
        currentAccountManager: null,
        lastModifiedUser: null,
        createUser: null,
      };
      this.portfolios = [emptyPortfolio].concat(this.portfolios);
    });
  }

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    let emptyLocality = <Locality>{
      localityId: null,
      countryId: null,
      isCapital: null,
      isCity: null,
      name: '',
    };
    this.localities = [emptyLocality].concat(lookupData.localitiesFull);
    this.industries = lookupData.customerIndustries;
    this.types = lookupData.customerTypes;
    this.customerFeedTypes = lookupData.customerFeedTypes;
    this.numberOfEmployees = lookupData.customerNumberOfEmployees;
    this.vatStatuses = lookupData.vatStatuses;
    this.customerContractTypes = lookupData.customerContractTypeList;
    this.loadPortfoliosDropDown();

    this.industryOptions = lookupData.industries
      .sort((a, b) => {
        const headsDiff = a.headId?.localeCompare(b.headId || '') || 0;
        if (headsDiff !== 0) {
          return headsDiff;
        }

        return a.isHead ? -1 : 1;
      })
      .map((c) => ({ label: c.name, value: c }));

    this.sub = this.route.params.subscribe((p) => {
      let customerId = +p['id'];
      this.customerId = customerId;
      this.tabIndex = this.route.snapshot.data['tabIndex'];
      this.load(this.customerId);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onCustomerUpdated(customerModel: CustomerModel) {
    this.load(customerModel.customerId);
  }
}
